<template>
  <div class="rule">
    <p class="head">兑换规则</p>
    <p class="msg">
      1、实物兑换需仔细填写收货地址，商品会在领取完毕后15个工作日内发送；
      <br>2、Q币兑换需仔细填写QQ号以及其他信息，商品会在3个工作日内充值到账；
      <br>3、京东卡兑换需加QQ群：878603037领取；
      <br>4、如有疑问请加Q群：878603037。
      <br>
    </p>
    <div class="cancle" @click="handleCancle"></div>
  </div>
</template>

<script>
export default {
  methods: {
    handleCancle() {
      this.$emit("cancle",{type:"Rule"});
    }
  }
};
</script>

<style lang="scss" scoped>
.rule {
  height: 600px;
  width: 950px;
  background: #fff;
  border-radius: 15px;
  padding: 40px;
  box-sizing: border-box;
  .head {
    font-size: 40px;
    margin-bottom: 84px;
    text-align: center;
  }
  .msg {
    font-size: 35px;
    line-height: 60px;
    color: #737373;
  }
  .cancle {
    position: absolute;
    bottom: -132px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 50px;
    background: url("../assets/guanbi.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
